import React, { useEffect, useState } from "react";
import { CommonUtilities } from "../../../commonUtils";
import Header from "../../Header/header";
import { Modal } from 'react-responsive-modal';
import UploadedFileBox from '../UploadedFile';
import TransactionServices from '../TransactionServices';


export default function ItunesMonthly(subEntity: any) {
    const [reportGetDate, setReportGetDate] = useState(false);
    const [getReportSuccess, setGetReportSuccess] = useState(false);
    const [proRateSucess, setproRateSucess] = useState(false);
    const [checkInvData, setCheckInvData] = useState(false);
    const [checkInvNoDate, setCheckInvNoDate] = useState(false);
    



    let [uploadFileStatus, setUploadFileStatus] = useState(false);
    const uploadFile = () => {
        setUploadFileStatus(true)
    }
    let [openUploadedFile, setOpenUploadedFile] = useState(false);
    const UploadedFileClose = () => {
        uploadFileStatus = false
        setUploadFileStatus(false)
    }


    

    let [collapsedGetInfo, setcollapsedGetInfo] = useState(false);
    let [collapsedUploadReport, setcollapsedUploadReport] = useState(false);
    let [collapsedViewReport, setcollapsedViewReport] = useState(false);


    return (
        <div className="ws-12 pm">

            <div className="ws-12">
                <div className="ws-12 box mb">
                    <div className="box-header well p0 pt prs">
                        <h2 className="ws-12 m0 pl full-width">
                            <i className="icon-file-add"></i> Get Report
                            <button className="icon-btn info pull-right m2" onClick={() => setcollapsedGetInfo(!collapsedGetInfo)}>
                                <i className={collapsedGetInfo ? 'icon-angle-up' : 'icon-angle-down'} ></i>
                            </button>
                        </h2>
                    </div>
                    {collapsedGetInfo && <>
                        <div className="box-content" data-ng-hide="getReportDsply">
                            <div className="row-fluid">

                                {
                                    reportGetDate && <div className="alert alert-info">Please select a month</div>
                                }
                                {
                                    getReportSuccess && <div className="alert alert-info">Generation of Report(s) in process</div>
                                }
                                <div className="ws-12">

                                    <div className="form-format ws-4">
                                        <label >Date</label>
                                        <div className="label-entries">
                                            <input type="text" placeholder="Select month and year" readOnly id="searchDate" name="searchDate" />

                                        </div>
                                    </div>

                                    <div className="form-format ws-4">
                                        <label >Territory</label>
                                        <div className="label-entries">
                                            <select data-ng-model="selectTerritory"  >
                                                <option value="" data-ng-selected="true" selected>All territories</option>
                                                <option data-ng-repeat="t in territories" value="AU" >Australia (AU)</option>
                                            </select>
                                        </div>
                                    </div>

                                    <div className="form-format ws-4">
                                        <label >Report</label>
                                        <div className="label-entries">
                                            <select data-ng-model="selectReport"  >
                                                <option value="" data-ng-selected="true" selected>All</option>
                                                <option data-ng-repeat="r in reports" value="Financial" >Standard Financial Royalty Reports (DRR)</option>

                                            </select>
                                        </div>
                                    </div>

                                </div>
                            </div>
                        </div>
                    

                    <div className="box-footer" data-ng-hide="getReportDsply">
                        <a className="icon-btn info pull-right" data-ng-click="getItunesReports(searchDate, selectTerritory, selectReport)">Get Report</a>
                    </div>
                    </>}
                </div>
                

                <div className="ws-12 box mb">
                    <div className="box-header well p0 pt prs">
                        <h2 className="ws-12 m0 pl full-width">
                            <i className="icon-upload"></i> Upload Report
                            <button className="icon-btn info pull-right m2" onClick={() => setcollapsedUploadReport(!collapsedUploadReport)}>
                                <i className={collapsedUploadReport ? 'icon-angle-up' : 'icon-angle-down'} ></i>
                            </button>
                        </h2>
                    </div>
                    {collapsedUploadReport && <>
                    <div className="box-content " data-ng-hide="getUplReportDsply">
                        <div className="alert alert-success " data-ng-hide="fileDetails.length &gt; 0">No report found </div>
                        <table className="table " data-ng-show="fileDetails.length &gt; 0">
                            <thead>
                                <tr>
                                    <th>Year &amp; Month</th>
                                    <th>Territory</th>
                                    <th>Report</th>
                                    <th>Operation</th>
                                </tr>
                            </thead>
                            <tbody>

                            </tbody>
                        </table>
                    </div>
                    <div className="box-footer " data-ng-show="!getUplReportDsply">
                        <a className="icon-btn delete pull-right" data-ng-click="getItunesFiles()">
                            <i className="icon-reload"></i> Refresh
                        </a>
                        <a className="icon-btn warning pull-right" onClick={() => uploadFile()}><i className="icon-file-add"></i>File History</a>

                        <a className="icon-btn info pull-right " data-ng-show="fileDetails.length &gt; 0" data-ng-click="loadFile('All', 'All', 'All')">
                            <i className="icon-upload"></i> Load All Files
                        </a>
                    </div>
                    </>}
                </div>

                <div className="ws-12 box mb">
                    <div className="box-header well p0 pt prs">
                        <h2 className="ws-12 m0 pl full-width">
                            <i className="icon-file-add"></i> View Report
                            <button className="icon-btn info pull-right m2" onClick={() => setcollapsedViewReport(!collapsedViewReport)}>
                                <i className={collapsedViewReport ? 'icon-angle-up' : 'icon-angle-down'} ></i>
                            </button>
                        </h2>
                    </div>
                    {collapsedViewReport && <>
                    <div className="box-content " data-ng-hide="getChkReportDsply">
                        <div className="mbl row-fluid">

                            <form name="frmCheckReport" >

                                <div className="form-format ws-4">
                                    <label >Date</label>
                                    <div className="label-entries">
                                        <input type="text" placeholder="Select month and year" data-ng-click="open($event,'checkDate')" data-ng-model="checkDate" is-open="datepickers.checkDate" readOnly id="checkDate" name="checkDate" />
                                    </div>
                                </div>

                                <div className="label-entries ptl ws-2">
                                    <a className="icon-btn edit " data-ng-click="getBalanceDetailsForDate(checkDate);">
                                        <div data-ng-hide="balanceDetails.length &gt; 0"><i className="icon-search1"></i> Check</div>
                                        <div data-ng-show="balanceDetails.length &gt; 0" ><i className="icon-reload"></i> Refresh</div>
                                    </a>
                                </div>
                            </form>
                        </div>
                        <div className="row-fluid">
                            <div className="table-responsive_big">
                                {
                                    proRateSucess && <div className="alert alert-info">Pro Rate successfully</div>
                                }
                                {
                                    checkInvData && <div className="alert alert-info">No data found for this month</div>
                                }
                                {
                                    checkInvNoDate && <div className="alert alert-info">Please select a month</div>
                                }
                                <table className="table " data-ng-show="balanceDetails.length &gt; 0">
                                    <thead>
                                        <tr>
                                            <th>Region/ Currency</th>
                                            <th>Post-Tax Subtotal</th>
                                            <th>Uploaded Total</th>
                                            <th></th>
                                            <th>Tax</th>
                                            <th>Adjustments</th>
                                            <th></th>
                                            <th>Pre-Tax Subtotal</th>
                                            <th></th>
                                            <th>FX Rate</th>
                                            <th>Currency</th>
                                            <th>Payment</th>
                                            <th></th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                    </tbody>
                                </table>
                            </div>
                        </div>
                        <div className="box-footer " data-ng-show="balanceDetails.length &gt; 0 ; !getChkReportDsply">

                            <a className="icon-btn info pull-right" data-ng-click="setProRate('ALL')">
                                <i className="icon-calculator"></i> Pro Rate All
                            </a>
                            <a className="icon-btn delete pull-right" data-ng-click="openViewData()">
                                <i className="icon-file-add"></i> View Data
                            </a>
                            <a className="icon-btn warning pull-right  " data-ng-show="invRefCheck.length == 1" data-ng-click="openGenerateInvoice()">
                                <i className="icon-plus1-circle"></i> Generate Invoice
                            </a>
                            <a className="icon-btn edit pull-right  " data-ng-show="invRefCheck.length &gt; 1" data-ng-click="">
                                Invoice:  ; Amount:
                            </a>

                            <a className="icon-btn edit pull-left" data-ng-click="openCheckFigure()">
                                <i className="icon-tick"></i> Check Export Figure
                            </a>

                            <a className="icon-btn edit pull-left" data-ng-click="summaryDetailsExport()">
                                <i className="icon-file-add"></i> Export Data
                            </a>
                        </div>
                    </div>
                    </>}
                </div>
            </div>

            {
                (() => {
                    if (uploadFileStatus) {
                        return <UploadedFileBox param={uploadFileStatus} UploadedFileClose={UploadedFileClose}/>
                    }
                })()
            }
        </div>
    );
}